import { Box, Typography } from '@mui/material';
import React from 'react';
import ParametersBank from '../components/Parameters/ParametersBank';
import { useDirection } from '../context/DirectionContext';
import { translate as tr } from '../i18n/translations';

/**
 * The unit's shared parameter bank (P5) — its own page, next to Forms, Stations and
 * Statements, since all three pick their parameters from it.
 */
const ParametersPage: React.FC = () => {
  const { lang } = useDirection();
  return (
    <Box>
      <Box sx={{ mb: 2.5 }}>
        <Typography sx={{ color: '#64748B', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 0.5 }}>
          {tr('nav.parameters', lang)}
        </Typography>
        <Typography variant="h5">{tr('param.tab', lang)}</Typography>
        <Typography sx={{ fontSize: '0.82rem', color: '#64748B', mt: 0.5 }}>{tr('param.bankHint', lang)}</Typography>
      </Box>
      <ParametersBank />
    </Box>
  );
};

export default ParametersPage;
